// soda-cli-plugin-gattaran-micro: 导入public-path，导入micro-utils
import './public-path.js'
import { initGtrUtils, IS_MICRO } from '@didi/gattaran-common-micro-utils'
import { getAuthParams, login } from '@/common/utils/login.js'
import { prefixUrl } from '@/common/utils/index.js'
import { getLocale } from '@didi/gettext'
import env from '@/common/utils/env.js'
import errorImg from '@/assets/error@3x.png'
import axios from '@didi/dajax'
import initElvish from './elvish'

function showErrorImg() {
  const imgElem = window.document.createElement('img')
  imgElem.src = errorImg
  imgElem.style = 'position: relative;left: 50%;margin: 100px 0 0 -78px;'
  window.document.getElementById('app').appendChild(imgElem)
}
// soda-cli-plugin-gattaran-micro: userinfo接口增加微前端环境判断并导出生命周期
if (!IS_MICRO) {
  import('@/common/utils/pageCalculation').then(({ default: PAGE }) => {
    console.log(PAGE)
    PAGE.saveLoadTime()
    axios
      .get(prefixUrl('/common'), {
        params: {
          ...getAuthParams(),
          api: 'common.getUserInfoV1',
        },
        timeout: 300000,
        needEncrypt: true,
      })
      .then(async (res) => {
        if (res.status !== 200) {
          showErrorImg()
          return res
        }
        const { errno, data } = res.data
        if (errno === 10000) {
          PAGE.saveLoginTime('loginReady')
          login(data)
          return data
        }
        if ((errno === 0 || errno === '0') && data) {
          // 计算getUserInfo接口请求时间
          PAGE.saveRequestTime()
          if (!data.locale) {
            data.locale = getLocale()
          }
          env.set('userInfo', data)
          // 计算登录成功时间
          PAGE.saveLoginTime('loginSuccess')
          await initElvish()
          import('./main.js')
          return res.data
        }
        showErrorImg()
      })
  })
  // 计算HTML加载时间
}
let microApp
// soda-cli-plugin-gattaran-micro: 导出基座所需生命周期
export async function bootstrap(props) {
  env.set('userInfo', props.GTR_USREINFO)
  initGtrUtils(props.GTR_UTILS)
}
export async function mount(config) {
  microApp = await import('./micro-app.js')
  microApp.render(config)
}
export async function unmount() {
  microApp.destory()
  microApp = null
}
